import React from 'react';
import { useTranslation } from 'react-i18next';
import { Step } from './Step';
import { CARD_PRETTY_STATUS } from '../constants';

const { CARD_ON_PRINT, SHIPPING, ACTIVATION_REQUIRED } = CARD_PRETTY_STATUS;

interface IStepActions {
  title: string;
  styles: string;
  linkUrl: string;
}

interface IStep {
  title: string;
  content: string;
  statusRef: number;
  appearOnActive: boolean;
  actions?: IStepActions[];
}

interface IProps {
  steps: IStep[];
  activeStep: number;
  shippingDate: Date | null;
}
export const TrackerStepContainer = ({ steps, activeStep, shippingDate }: IProps) => {
  const shouldShowShippingDate = () => {
    const validShippingDateStatuses = [CARD_ON_PRINT, SHIPPING, ACTIVATION_REQUIRED];
    return validShippingDateStatuses.includes(activeStep);
  };

  const { t } = useTranslation();

  return (
    <div className='w-full px-[23.5px]'>
      {steps.map((step, idx) => {
        if (step.appearOnActive) {
          if (activeStep === step.statusRef) {
            return (
              <Step
                key={step.statusRef}
                shippingDate={shouldShowShippingDate() ? shippingDate || null : null}
                title={t(step.title, step.title)}
                content={t(step.content, step.content)}
                isLastStep={idx === steps.length - 1}
                isActive={step.statusRef === activeStep}
              />
            );
          }
          return '';
        }
        return (
          <Step
            key={step.statusRef}
            shippingDate={shouldShowShippingDate() ? shippingDate || null : null}
            title={t(step.title, step.title)}
            content={t(step.content, step.content)}
            isLastStep={idx === steps.length - 1}
            isActive={step.statusRef === activeStep}
          />
        );
      })}
    </div>
  );
};
